var utils = require('./canvas-utils');

var module = angular.module('bbl.module.view-screenshare');

module.directive('slidesDrawCanvas', ['$parse', '$q', function($parse, $q) {
  return {
    template: '<div class="slideshare-canvas-wrap"><ng-transclude></ng-transclude><canvas id="slideshare-canvas"></canvas></div>',
    restrict: 'EA',
    transclude: true,

    link: function($scope, $el, $atts) {
      var allowDrawing = $parse($atts.allowDrawing)($scope);
      var canvas = $el.find('#slideshare-canvas');
      var drawCb = utils.throttle($scope.draw, 100);
      utils.allowDrawing(canvas[0], allowDrawing, drawCb);
      var $ready = $q.defer();

      function updateCanvasSize() {
        var img = $el.find('.slide.active img')[0];
        if (!img) {
          return;
        } else if(!img.complete || !img.naturalWidth) {
          return $(img).on('load', updateCanvasSize);
        }

        var sizes = utils.getImgSizeInfo(img);
        canvas.css({width: sizes.width, height: sizes.height});
        canvas[0].width = sizes.width;
        canvas[0].height = sizes.height;
        $ready.resolve();
      }

      $scope.$watch('slidesData.current', updateCanvasSize);
      $scope.$watch('slidesData.drawPoints', function(data) {
        $ready.promise.then(function() {
          canvas.trigger('update', [data]);
        });
      });

      setTimeout(updateCanvasSize, 150);
    },
  };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/view-screenshare/slideshare/draw-canvas.js
 ** module id = 402
 ** module chunks = 0
 **/